import React from 'react';
import { ApplicationView } from '@aha-app/mvc';

export const ContentError = ({ message }: { message: string }) => {
  return (
    <span
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <i className='far fa-file-circle-question' /> {message}
    </span>
  );
};

export default ApplicationView(ContentError);
